import React, { useEffect, useState } from 'react'
import OTPInput from 'react-otp-input'
import Handler from '../../../../Helpers/Handler'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { contentLoadingChange } from '../../../../Reducer/componentSlice'
import { useAuth } from '../../../../Contexts/AuthenticateProvider'

// Ported from the uploaded reference EmailStage.js, fields/flow unchanged:
// send OTP to a new/updated email, then verify it. Wired to the real
// endpoints (PATCH, matching ClientValidation.emailUpdate/emailVerify) and
// gated by associate.edit, following the same defense-in-depth pattern as
// CustomerVerification/EmailStage.js (the tile that opens this stage is
// already hidden without the capability - this guards the submit handlers
// too, in case the stage is ever reached another way).
const EmailStage = ({ associateDetails, onVerified }) => {
    const dispatch = useDispatch()
    const { hasPermission } = useAuth()
    const canSubmit = hasPermission("associate.edit")

    const [emailData, setEmailData] = useState({ email: "", otp: "" })
    const [otpview, setOtpview] = useState(false)
    const [loading, setLoading] = useState(false)

    const sendOtp = async () => {
        if (!canSubmit) return toast.error("You don't have permission to edit this associate")
        if (!emailData?.email) return toast.error("Invalid Email")
        dispatch(contentLoadingChange(true))
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/staff/client/associate/email/otp/${associateDetails?.associateId}`, data: { email: emailData?.email } })
        if (response?.success) {
            toast.success(response?.data?.message || "OTP Sent")
            setOtpview(true)
        } else {
            toast.error(response?.data?.message || "Failed to send OTP")
        }
        dispatch(contentLoadingChange(false))
        setLoading(false)
    }

    const verifyOtp = async () => {
        if (!canSubmit) return toast.error("You don't have permission to edit this associate")
        if (!emailData?.email) return toast.error("Invalid Email")
        if (!emailData?.otp || emailData?.otp?.length !== 5) return toast.error("Invalid OTP")
        dispatch(contentLoadingChange(true))
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/staff/client/associate/email/verify/${associateDetails?.associateId}`, data: { email: emailData?.email, otp: emailData?.otp } })
        if (response?.success) {
            toast.success(response?.data?.message || "OTP Verified")
            dispatch(contentLoadingChange(false))
            setTimeout(() => {
                setLoading(false)
                onVerified?.()
            }, 1500)
        } else {
            toast.error(response?.data?.message || "OTP verification failed")
            dispatch(contentLoadingChange(false))
            setLoading(false)
        }
    }

    useEffect(() => {
        setEmailData({ email: associateDetails?.email?.emailId || "", otp: "" })
        setOtpview(false)
    }, [associateDetails])

    return (
        <>
            {!canSubmit ? (
                <div className="alert alert-warning small mb-3">
                    You don't have permission to edit this associate's email verification.
                </div>
            ) : null}
            <div className="mb-3">
                <label htmlFor="email" className="form-label">Email address</label>
                <input type="email" className="form-control" disabled={otpview || loading || !canSubmit} id="email" autoComplete='off' value={emailData?.email} onChange={(e) => setEmailData((prev) => ({ ...prev, email: e?.target?.value }))} />
            </div>
            {otpview && (
                <div className="mb-5">
                    <label className="form-label">OTP</label>
                    <OTPInput
                        value={emailData?.otp}
                        onChange={(e) => setEmailData((prev) => ({ ...prev, otp: e }))}
                        numInputs={5}
                        renderSeparator={<span className="mx-1"></span>}
                        renderInput={(props) => (
                            <input {...props} disabled={loading} className="form-control text-center mx-1" style={{ width: "45px", height: "45px" }} />
                        )}
                    />
                </div>
            )}
            <div className='text-center my-2'>
                {otpview ? (
                    <button className='btn btn-primary' disabled={loading || !canSubmit} onClick={verifyOtp}>Verify Otp</button>
                ) : (
                    <button className='btn btn-primary' disabled={loading || !canSubmit} onClick={sendOtp}>Send Otp</button>
                )}
            </div>
        </>
    )
}

export default EmailStage
